import appConstants from "@appConstants";

const { DELIVERY_STATUS } = appConstants;

/**
 * Maps return/exception codes to display strings using client code lists.
 * Format: "Return (description)" or "Delivery Exception (description)".
 * Falls back to raw codes when lists are missing or code not found.
 */
const getStopStatusCodesWithDescriptions = (
  codes,
  returnCodeList,
  exceptionList,
  enableReturnExceptionReasonLabels = false
) => {
  if (!codes?.length) return "";
  if (!enableReturnExceptionReasonLabels) {
    return codes.join(",");
  }
  if (!returnCodeList?.length && !exceptionList?.length) {
    return codes.join(",");
  }
  return codes
    .map((code) => {
      const returnMatch = returnCodeList?.find((item) => item.value === code);
      if (returnMatch) {
        return `${DELIVERY_STATUS.RETURN} (${returnMatch.label})`;
      }
      const exceptionMatch = exceptionList?.find((item) => item.value === code);
      if (exceptionMatch) {
        return `${DELIVERY_STATUS.DELIVERY_EXCEPTION} (${exceptionMatch.labelText})`;
      }
      return code;
    })
    .join(", ");
};

export { getStopStatusCodesWithDescriptions, DELIVERY_STATUS };
